import React, { useState } from "react";
import contentfulClient from "../../../../services/contentful";
import { useQuery } from "react-query";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import { useMiddlewareOffer } from "src/hooks/useMiddlewareOffer";
import { useMedia } from "use-media";
import * as S from "./styles";
import Loading from "src/components/Loading";
import CardPlan from "./CardPlan";
import Footer from "./Footer";
import Plans from "./Plans";
import { addHours, isAfter, isToday, isWithinInterval } from "date-fns";

function Planos() {
  const content = useFetchContent();
  const { data } = useMiddlewareOffer();
  const isMobile = useMedia({ maxWidth: 767 });
  const isMd = useMedia({ minWidth: 1050 });

  const section = getSection({
    sectionName: "landingDefaultPromo",
    data: content.data,
  });

  const typePlans = ["pedagiosEstacionamentos", "estacionamentos", "pedagios"];

  const plans = useQuery(
    "getCardPlan",
    () =>
      Promise.all(
        typePlans
          .filter((field) => Object.keys(section).includes(field))
          .map(
            async (field) =>
              await contentfulClient.getEntry(section[field].sys.id)
          )
      ),
    {
      enabled: content.data && !content.isLoading,
      retry: false,
    }
  );

  const list = plans.data?.map((data, index) => {
    const { fields, ...props } = data
    return (
      <>
        <CardPlan item={fields} data={data} key={index} />
      </>
    )
  });

  if (!plans.data) return <Loading />;

  const adesaoText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "+ taxa única de adesão Grátis*"

		return '+ Adesão única de apenas R$20 por tag'
	}

  const bonusText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "* Condição válida até 14/12/24."

		return null
  }

  const newPlans = {
      "data": [
          {
            "fields": {
              "benefits": [
                {
                  "tab": "Cartões de crédito",
                  "cards": [
                    {
                      "title": "1 tag com mensalidade grátis!",
                      "benefits": [
                        "Para cartões com faturas a partir de R$2mil*",
                        adesaoText()
                      ],
                      "info": bonusText(),
                      "footer": [
                        "Não atingiu a fatura mínima? A mensalidade sairá por apenas R$5."
                      ]
                    },
                    {
                      "title": "A partir da 2ª tag: 6 mensalidades grátis",
                      "benefits": [
                        "Após esse período, a mensalidade será de R$14,90 por tag adicional.",
                        adesaoText()
                      ],
                      "info": bonusText(),
                      "footer": []
                    }
                  ]
                },
                {
                  "tab": "Cartões de débito",
                  "cards": [
                    {
                      "title": "Por apenas R$5 ao mês",
                      "benefits": [
                        adesaoText(),
                        "Se preferir, peça seu cartão de crédito através do app Bradesco ou fale com seu gerente"
                      ],
                      "footer": [
                        "Clique na aba de cartão de crédito e veja as condições"
                      ]
                    }
                  ]
                }
              ]
            }
          }
        ]
  }

  const fields = newPlans.data.map(item => item.fields)
  const { benefits } = fields.length > 0 ? fields[0] : { benefits: [] }

  return (
    <S.Container id="plans">
      <S.Title>{section.title}</S.Title>
      <S.Wrapper>
      <S.Content>
        <S.ContainerPlan>
            <Plans benefits={benefits}/>
        </S.ContainerPlan>
        <S.MainImage>
          <div />
          <img src='/bradescoexclusive/assets/card_iPhone_15.png' alt='Bradesco e smartphone'/>
        </S.MainImage>
      </S.Content>
      <Footer
        buttonColor={section.buttonColor}
        terms={section.regulamento}
        textColor={"#FFFFFF"}
        cupons={[plans.data[0].fields.firstButtonCoupon]}
      />
      </S.Wrapper>
    </S.Container>
  );
}
export default Planos;
